(function () {
  const initDesktopMegaMenu = (header) => {
    const megaMenuLinks = header.querySelectorAll(
      ".header-inline-menu__item--megamenu, header-sidebar .header-sidebar__nav-item--megamenu"
    );
    if (!megaMenuLinks || !megaMenuLinks.length) return;

    megaMenuLinks.forEach((link) => {
      const megaMenuEl = link.querySelector(".mega-menu");
      if (!megaMenuEl) return;

      const megaMenuPlaceholderList = link.querySelector(
        ".mega-menu .mega-menu-list--placeholder"
      );
      if (megaMenuPlaceholderList) {
        document
          .querySelectorAll("svg.placeholder-svg g[clip-path]")
          .forEach((el) => {
            el.removeAttribute("clip-path");
          });
      }

      megaMenuEl.classList.add("mega-menu--initialized");
    });

    const headerEl = header.querySelector(
      ".header--layout-segmented .header-inner, .header--layout-standard .header-inner, header-sidebar"
    );
    if (!headerEl) return;

    const isSidebar = headerEl.closest("header-sidebar") !== null;

    const calcMegaMenuPosition = () => {
      const headerRect = headerEl.getBoundingClientRect();

      megaMenuLinks.forEach((link) => {
        const megaMenuEl = link.querySelector(".mega-menu");
        if (!megaMenuEl) return;

        const linkMenuRect = link.getBoundingClientRect();
        const megaMenuRect = megaMenuEl.getBoundingClientRect();

        link.addEventListener("mouseleave", () => {
          const focusElement = document.activeElement;
          if (link.contains(focusElement)) {
            focusElement.blur();
          }
        });

        if (isSidebar) {
          const calcPositionInSidebar = () => {
            const headerRect = headerEl.getBoundingClientRect();
            const linkMenuRect = link.getBoundingClientRect();
            const extraTop = Math.ceil(linkMenuRect.top - headerRect.top);
            const extraHeight = Math.ceil(linkMenuRect.height);
            megaMenuEl.style.setProperty("--extra-top", `${extraTop}px`);
            megaMenuEl.style.setProperty("--extra-height", `${extraHeight}px`);
          };

          calcPositionInSidebar();

          headerEl.addEventListener("scroll", () => {
            if (window.innerWidth >= 1160) {
              calcPositionInSidebar();
            }
          });

          link.addEventListener("mouseenter", () => {
            if (window.innerWidth >= 1160) {
              calcPositionInSidebar();
            }
          });

          return;
        }

        const extraHeight = Math.abs(linkMenuRect.bottom - megaMenuRect.top);
        const extraHeightFix = Math.ceil(extraHeight);
        const extraLeft = Math.ceil(linkMenuRect.left - headerRect.left - 8);
        const extraWidth = Math.ceil(linkMenuRect.width + 16);

        megaMenuEl.style.setProperty("--extra-height", `${extraHeightFix}px`);
        megaMenuEl.style.setProperty("--extra-left", `${extraLeft}px`);
        megaMenuEl.style.setProperty("--extra-width", `${extraWidth}px`);
      });
    };

    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        calcMegaMenuPosition();
      });
    });

    observer.observe(headerEl);
  };

  const initMobileMegaMenu = (header) => {
    const megaMenuLinks = header.querySelectorAll(
      "header-mobile-drawer .header-sidebar__nav-item--megamenu"
    );
    if (!megaMenuLinks || !megaMenuLinks.length) return;

    const openMobileMegaMenu = (megaMenuEl) => {
      if (!megaMenuEl || !megaMenuEl.classList.contains("mega-menu-mobile")) {
        return;
      }

      megaMenuEl.classList.add("mega-menu-mobile--visible");
      trapFocus(megaMenuEl.querySelector(".mega-menu-mobile__wrapper"));
    };

    const closeMobileMegaMenu = (megaMenuEl, parentLink) => {
      if (!megaMenuEl || !megaMenuEl.classList.contains("mega-menu-mobile")) {
        return;
      }

      megaMenuEl.classList.remove("mega-menu-mobile--visible");
      removeTrapFocus(parentLink);
    };

    megaMenuLinks.forEach((item) => {
      const linkEl = item.querySelector(".header-sidebar__nav-link");
      const megaMenuEl = item.querySelector(".mega-menu-mobile");
      if (!linkEl || !megaMenuEl) return;

      const closeButton = megaMenuEl.querySelector(
        ".js-mega-menu-mobile-close-trigger"
      );

      linkEl.addEventListener("click", (event) => {
        event.preventDefault();
        openMobileMegaMenu(megaMenuEl);
      });

      closeButton.addEventListener("click", (event) => {
        event.preventDefault();
        closeMobileMegaMenu(megaMenuEl, linkEl);
      });

      megaMenuEl.classList.add("mega-menu-mobile--initialized");
    });
  };

  const initDesktopMegaSubmenu = (header) => {
    const megaSubmenuLinks = header.querySelectorAll(
      ".header-inline-menu__item--megasubmenu, header-sidebar .header-sidebar__nav-item--megasubmenu"
    );
    if (!megaSubmenuLinks || !megaSubmenuLinks.length) return;

    megaSubmenuLinks.forEach((link) => {
      const megaSubmenuEl = link.querySelector(".mega-submenu");
      if (!megaSubmenuEl) return;

      const hasSvgPlaceholder = megaSubmenuEl.querySelector(
        ".header-promo-card .placeholder-svg"
      );

      if (hasSvgPlaceholder) {
        document
          .querySelectorAll("svg.placeholder-svg g[clip-path]")
          .forEach((el) => {
            el.removeAttribute("clip-path");
          });
      }

      megaSubmenuEl.classList.add("mega-submenu--initialized");
    });

    const headerEl = header.querySelector(
      ".header--layout-segmented .header-inner, .header--layout-standard .header-inner, header-sidebar"
    );
    if (!headerEl) return;

    const isSidebar = headerEl.closest("header-sidebar") !== null;

    const calcMegaSubmenuPosition = () => {
      const headerRect = headerEl.getBoundingClientRect();

      megaSubmenuLinks.forEach((link) => {
        const megaSubmenuEl = link.querySelector(".mega-submenu");
        if (!megaSubmenuEl) return;

        const linkMenuRect = link.getBoundingClientRect();
        const megaSubmenuRect = megaSubmenuEl.getBoundingClientRect();

        link.addEventListener("mouseleave", () => {
          const focusElement = document.activeElement;
          if (link.contains(focusElement)) {
            focusElement.blur();
          }
        });

        if (isSidebar) {
          const calcPositionInSidebar = () => {
            const headerRect = headerEl.getBoundingClientRect();
            const linkMenuRect = link.getBoundingClientRect();
            const extraTop = Math.ceil(linkMenuRect.top - headerRect.top);
            const extraHeight = Math.ceil(linkMenuRect.height);
            megaSubmenuEl.style.setProperty("--extra-top", `${extraTop}px`);
            megaSubmenuEl.style.setProperty(
              "--extra-height",
              `${extraHeight}px`
            );
          };

          calcPositionInSidebar();

          headerEl.addEventListener("scroll", () => {
            if (window.innerWidth >= 1160) {
              calcPositionInSidebar();
            }
          });

          link.addEventListener("mouseenter", () => {
            if (window.innerWidth >= 1160) {
              calcPositionInSidebar();
            }
          });

          return;
        }

        const extraHeight = Math.abs(linkMenuRect.bottom - megaSubmenuRect.top);
        const extraHeightFix = Math.ceil(extraHeight);
        const extraLeft = Math.ceil(linkMenuRect.left - headerRect.left - 8);
        const extraWidth = Math.ceil(linkMenuRect.width + 16);

        megaSubmenuEl.style.setProperty(
          "--extra-height",
          `${extraHeightFix}px`
        );
        megaSubmenuEl.style.setProperty("--extra-left", `${extraLeft}px`);
        megaSubmenuEl.style.setProperty("--extra-width", `${extraWidth}px`);
      });
    };

    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        calcMegaSubmenuPosition();
      });
    });

    observer.observe(headerEl);
  };

  const initMobileMegaSubmenu = (header) => {
    const megaSubmenuLinks = header.querySelectorAll(
      "header-mobile-drawer .header-sidebar__nav-item--megasubmenu"
    );
    if (!megaSubmenuLinks || !megaSubmenuLinks.length) return;

    const openMobileMegaSubmenu = (megaSubmenuEl) => {
      if (
        !megaSubmenuEl ||
        !megaSubmenuEl.classList.contains("mega-submenu-mobile")
      ) {
        return;
      }

      megaSubmenuEl.classList.add("mega-submenu-mobile--visible");
      trapFocus(megaSubmenuEl.querySelector(".mega-submenu-mobile__wrapper"));
    };

    const closeMobileMegaSubmenu = (megaSubmenuEl, parentLink) => {
      if (
        !megaSubmenuEl ||
        !megaSubmenuEl.classList.contains("mega-submenu-mobile")
      ) {
        return;
      }

      megaSubmenuEl.classList.remove("mega-submenu-mobile--visible");
      removeTrapFocus(parentLink);
    };

    megaSubmenuLinks.forEach((item) => {
      const linkEl = item.querySelector(".header-sidebar__nav-link");
      const megaSubmenuEl = item.querySelector(".mega-submenu-mobile");
      if (!linkEl || !megaSubmenuEl) return;

      const closeButton = megaSubmenuEl.querySelector(
        ".js-mega-submenu-mobile-close-trigger"
      );

      linkEl.addEventListener("click", (event) => {
        event.preventDefault();
        openMobileMegaSubmenu(megaSubmenuEl);
      });

      closeButton.addEventListener("click", (event) => {
        event.preventDefault();
        closeMobileMegaSubmenu(megaSubmenuEl, linkEl);
      });

      megaSubmenuEl.classList.add("mega-submenu-mobile--initialized");
    });
  };

  const initDesktopSubmenu = (header) => {
    const headerBox = header.querySelector(
      ".header--layout-segmented .header-inner, .header--layout-standard .header-inner"
    );
    if (!headerBox) return;

    const submenuItems = headerBox.querySelectorAll(
      ".header-inline-menu__item--submenu"
    );
    if (!submenuItems || !submenuItems.length) return;

    const calcSubmenuPosition = () => {
      const headerRect = headerBox.getBoundingClientRect();

      submenuItems.forEach((itemEl) => {
        const submenuEl = itemEl.querySelector(".header-inline-submenu");
        if (!submenuEl) return;

        const itemRect = itemEl.getBoundingClientRect();

        const delta = headerRect.bottom - itemRect.bottom + 10;
        const distanceToMenu = Math.ceil(delta / 10) * 10;

        submenuEl.style.top = `calc(100% + ${delta}px)`;
        itemEl.style.setProperty("--distance-to-menu", `${distanceToMenu}px`);
      });
    };

    const observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        calcSubmenuPosition();
      });
    });

    observer.observe(headerBox);

    submenuItems.forEach((itemEl) => {
      itemEl.addEventListener("mouseleave", () => {
        const focusElement = document.activeElement;
        if (itemEl.contains(focusElement)) {
          focusElement.blur();
        }
      });
    });
  };

  const initHeaderOverlay = (header) => {
    const main = document.getElementById("MainContent");
    const sections = main.querySelectorAll(".shopify-section");
    const isSegmentedMode = Boolean(
      header.querySelector(".header--layout-segmented")
    );
    const isSidebarMode = Boolean(header.querySelector("header-sidebar"));
    const breadcrumbs = document.querySelector("#breadcrumbs");

    const removeColorScheme = (element) => {
      if (!element) return;
      let classNames = element.getAttribute("class");
      classNames = classNames.replace(/color-background-\d+/g, "");
      element.setAttribute("class", classNames);
    };

    if (sections.length > 0 && (isSegmentedMode || isSidebarMode)) {
      const hasTargetSection = sections[0].classList.contains(
        "has-header-interaction"
      );
      const sectionTargetChild = sections[0].querySelector(
        "[data-header-interaction]"
      );
      const headerGroupSections = document.querySelectorAll(
        ".shopify-section-group-header-group"
      );

      if (hasTargetSection && sectionTargetChild) {
        if (headerGroupSections[headerGroupSections.length - 1] === header) {
          sections[0].classList.remove("not-margin");
          header.classList.remove("not-mode");
          if (breadcrumbs) {
            removeColorScheme(breadcrumbs);
            const colorScheme = sectionTargetChild.dataset.colorScheme;
            if (colorScheme) breadcrumbs.classList.add(`color-${colorScheme}`);
          }
        } else {
          sections[0].classList.add("not-margin");
          header.classList.add("not-mode");
          if (breadcrumbs) removeColorScheme(breadcrumbs);
        }
      } else {
        header.classList.add("not-mode");
        if (breadcrumbs) removeColorScheme(breadcrumbs);
      }
    } else {
      header.classList.add("not-mode");
      if (breadcrumbs) removeColorScheme(breadcrumbs);
    }
  };

  const initHeaderShadowOnHover = (header) => {
    if (!header.querySelector(".header--layout-standard")) {
      return;
    }

    const hoverItems = header.querySelectorAll(
      ".header-inline-menu__item--submenu, .header-inline-menu__item--megamenu, .header-inline-menu__item--megasubmenu"
    );
    if (!hoverItems.length) return;

    let isHovering = false;

    const addShadow = () => {
      if (!isHovering && window.innerWidth >= 1160) {
        isHovering = true;
        header.style.boxShadow =
          "0px 8px 14px 0px rgba(var(--color-shadow), 0.08)";
      }
    };

    const removeShadow = () => {
      if (isHovering) {
        isHovering = false;
        header.style.boxShadow = "";
      }
    };

    hoverItems.forEach((item) => {
      item.addEventListener("mouseenter", addShadow);
      item.addEventListener("mouseleave", removeShadow);
    });
  };

  const initHeader = () => {
    const header = document.querySelector(".shopify-section-header");
    if (!header) return;

    initHeaderOverlay(header);
    initDesktopMegaMenu(header);
    initMobileMegaMenu(header);
    initDesktopMegaSubmenu(header);
    initMobileMegaSubmenu(header);
    initDesktopSubmenu(header);
    initHeaderShadowOnHover(header);
  };

  initHeader();

  document.addEventListener("shopify:section:load", initHeader);
  document.addEventListener("shopify:section:unload", initHeader);
  document.addEventListener("shopify:section:reorder", initHeader);
})();

if (!customElements.get("header-sidebar")) {
  customElements.define(
    "header-sidebar",
    class HeaderSidebar extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.checkSidebarScrollbar();
        this.getBrowserScrollbarWidth();
      }

      checkSidebarScrollbar() {
        const observer = new ResizeObserver(() => {
          const hasScroll = this.scrollHeight > this.clientHeight;
          const scrollbarWidth = this.offsetWidth - this.clientWidth;

          if (hasScroll) {
            this.style.setProperty(
              "--inner-scrollbar-width",
              `${scrollbarWidth}px`
            );
            this.classList.add("has-scroll");
          } else {
            this.style.removeProperty("--inner-scrollbar-width");
            this.classList.remove("has-scroll");
          }
        });

        observer.observe(this);
      }

      getBrowserScrollbarWidth() {
        const calcScrollbarWidth = () => {
          const div = document.createElement("div");
          div.style.cssText =
            "width: 100px; height: 100px; overflow-y: scroll; position: absolute; top: -9999px;";
          document.body.appendChild(div);
          const browserScrollbarWidth = div.offsetWidth - div.clientWidth;
          document.body.removeChild(div);
          document.documentElement.style.setProperty(
            "--browser-scrollbar-width",
            `${browserScrollbarWidth}px`
          );
        };

        calcScrollbarWidth();

        window.addEventListener("resize", calcScrollbarWidth);

        this._cleanupScrollbarListener = () => {
          window.removeEventListener("resize", calcScrollbarWidth);
        };
      }

      disconnectedCallback() {
        if (this._cleanupScrollbarListener) {
          this._cleanupScrollbarListener();
        }
      }
    }
  );
}

if (!customElements.get("header-settings")) {
  customElements.define(
    "header-settings",
    class HeaderSettings extends HTMLElement {
      constructor() {
        super();

        this._onOpen = this.openSettings.bind(this);
        this._onClose = this.closeSettings.bind(this);
        this._onOutsideClick = this.onOutsideClick.bind(this);
      }

      connectedCallback() {
        const prevElement = this.previousElementSibling;
        this.openBtn = prevElement?.classList.contains("js-settings-trigger")
          ? prevElement
          : null;
        this.closeBtn = this.querySelector(".js-settings-close-trigger");

        if (!this.openBtn || !this.closeBtn) return;

        this.openBtn.addEventListener("click", this._onOpen);
        this.closeBtn.addEventListener("click", this._onClose);
        document.addEventListener("click", this._onOutsideClick);
      }

      disconnectedCallback() {
        this.openBtn.removeEventListener("click", this._onOpen);
        this.closeBtn.removeEventListener("click", this._onClose);
        document.removeEventListener("click", this._onOutsideClick);
      }

      openSettings() {
        if (!this.classList.contains("header-settings--visible")) {
          this.classList.add("header-settings--visible");
          this.addEventListener("transitionend", () => {
            trapFocus(this);
          });
        } else {
          this.closeSettings();
        }
      }

      closeSettings() {
        this.classList.remove("header-settings--visible");
        removeTrapFocus(this.openBtn);
      }

      onOutsideClick(event) {
        if (
          !this.classList.contains("header-settings--visible") ||
          this.contains(event.target) ||
          this.openBtn.contains(event.target)
        ) {
          return;
        }
        this.closeSettings();
      }
    }
  );
}

if (!customElements.get("header-search")) {
  customElements.define(
    "header-search",
    class HeaderSearch extends HTMLElement {
      constructor() {
        super();

        this.open = this.onOpen.bind(this);
        this.close = this.onClose.bind(this);
        this.onKeyDownBody = this.onKeydownBody.bind(this);
        this.onKeyDownOption = this.onKeydownOption.bind(this);
        this.onKeyUpOption = this.onKeyupOption.bind(this);
      }

      connectedCallback() {
        this.header = document.querySelector(".header-wrapper");
        this.openBtn = this.querySelector(".js-search-modal-trigger");
        this.modalEl = document.querySelector(".header-search-modal");
        if (!this.modalEl) return;

        this.overlayEl = document.querySelector(".header-search-modal-overlay");
        this.closeBtn = this.modalEl.querySelector(".js-search-close-trigger");
        this.input = this.modalEl.querySelector("#Search-In-Modal");
        this.menuEl = this.modalEl.querySelector(".header-search-modal__menu");
        this.predictiveSearchEl =
          this.modalEl.querySelector("predictive-search");

        this.isMac = this.identifyDevice();

        this.openBtn?.addEventListener("click", this.open);
        this.closeBtn?.addEventListener("click", this.close);
        this.overlayEl?.addEventListener("click", this.close);

        document.body.addEventListener("keydown", this.onKeyDownBody);
        this.modalEl.addEventListener("keydown", this.onKeyDownOption);
        this.modalEl.addEventListener("keyup", this.onKeyUpOption);
      }

      disconnectedCallback() {
        document.body.removeEventListener("keydown", this.onKeyDownBody);
      }

      onOpen(event) {
        if (event) event.preventDefault();
        if (this.header) this.header.preventHide = true;
        this.isOpen = true;
        this.modalEl.setAttribute("open", true);
        if (this.openBtn) this.openBtn.setAttribute("aria-expanded", "true");

        this.modalEl.addEventListener(
          "transitionend",
          () => {
            if (this.isOpen) {
              trapFocus(this.modalEl, this.input);
            }
          },
          { once: true }
        );

        document.body.classList.add("overflow-hidden-search-open");
      }

      onClose(event, elementToFocus = null) {
        if (event) event.preventDefault();
        if (!this.isOpen) return;
        this.isOpen = false;
        this.modalEl.removeAttribute("open");
        if (this.openBtn) this.openBtn.setAttribute("aria-expanded", "false");
        if (this.header) this.header.preventHide = false;

        document.body.classList.remove("overflow-hidden-search-open");

        if (this.input) {
          this.input.setAttribute("aria-activedescendant", "");
        }

        const newFocusElement = elementToFocus ? elementToFocus : this.openBtn;
        removeTrapFocus(newFocusElement);
      }

      onKeyupOption(event) {
        const isOpen = this.modalEl.getAttribute("open");
        if (!isOpen || !(this.menuEl || this.predictiveSearchEl)) return;
        if (event.code === "Enter") {
          const target = event.target;

          if (target.tagName.toLowerCase() === "button") {
            return;
          }

          event.preventDefault();
          this.selectOption();
        }
      }

      onKeydownOption(event) {
        const isOpen = this.modalEl.getAttribute("open");
        if (!isOpen || !(this.menuEl || this.predictiveSearchEl)) return;

        if (event.code === "ArrowUp" || event.code === "ArrowDown") {
          const targetTag = event.target.tagName.toLowerCase();
          if (
            targetTag !== "input" &&
            targetTag !== "a" &&
            targetTag !== "div"
          ) {
            return;
          }

          event.preventDefault();
          event.stopImmediatePropagation();
          this.switchOption(event.code === "ArrowUp" ? "up" : "down");
        }
      }

      onKeydownBody(event) {
        const isOpen = this.modalEl.getAttribute("open");

        if (isOpen && event.key === "Escape") {
          this.close();
          return;
        }

        if (!isOpen) {
          const key = event?.key?.toLowerCase();
          const isMac = this.isMac;
          const isCmdK = isMac && event?.metaKey && key === "k";
          const isCtrlK = !isMac && event?.ctrlKey && key === "k";

          if (isCmdK || isCtrlK) {
            event.preventDefault();
            this.open();
          }
        }
      }

      switchOption(direction) {
        if (!this.modalEl.getAttribute("open")) return;

        const moveUp = direction === "up";
        const selectedElement = this.modalEl.querySelector(
          '[aria-selected="true"]'
        );

        const allVisibleElements = Array.from(
          this.modalEl.querySelectorAll("[role='option']")
        ).filter((element) => element.offsetParent !== null);

        if (allVisibleElements.length === 0) return;

        let selectedElementIndex = allVisibleElements.indexOf(selectedElement);
        let activeElementIndex = 0;

        if (selectedElementIndex === -1) {
          activeElementIndex = moveUp ? allVisibleElements.length - 1 : 0;
        } else {
          if (moveUp) {
            activeElementIndex =
              selectedElementIndex === 0
                ? allVisibleElements.length - 1
                : selectedElementIndex - 1;
          } else {
            activeElementIndex =
              selectedElementIndex === allVisibleElements.length - 1
                ? 0
                : selectedElementIndex + 1;
          }
        }

        if (this.predictiveSearchEl && this.predictiveSearchEl.statusElement) {
          this.predictiveSearchEl.statusElement.textContent = "";
        }

        const activeElement = allVisibleElements[activeElementIndex];
        if (!activeElement) return;

        activeElement.setAttribute("aria-selected", true);
        if (selectedElement) {
          selectedElement.setAttribute("aria-selected", false);
        }

        if (this.input) {
          this.input.setAttribute("aria-activedescendant", activeElement.id);
        }

        activeElement.scrollIntoView({
          block: "nearest",
          inline: "nearest",
          behavior: "smooth",
        });
      }

      selectOption() {
        const selectedOption = this.modalEl.querySelector(
          '[aria-selected="true"] a'
        );
        if (selectedOption) selectedOption.click();
      }

      identifyDevice() {
        const isMac =
          /Mac/.test(navigator.platform) ||
          navigator.userAgentData?.platform?.toLowerCase() === "macos" ||
          navigator.userAgentData?.platform?.toLowerCase().includes("mac");

        const shortKeyEl = this.openBtn.querySelector("[data-device-type]");
        if (shortKeyEl) {
          shortKeyEl.dataset.deviceType = isMac ? "mac" : "windows";
        }

        return isMac;
      }
    }
  );
}
